import { SnackbarProvider } from "notistack";
import { Button, Slide } from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Routers from "./routes";
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/index.css";
import "./assets/css/style.css";
import "./assets/css/chat.css";
import { ContextPGIMode } from "./Hooks/PGIModeContext";
import { Helmet } from "react-helmet";
import { useContentSetting } from "./Hooks/ContentSettingState";
import { _get_consultant_from_localStorage } from "./DAL/localstorage/LocalStorage";
import { ChatContext } from "./Hooks/ChatContext";
import { loginLogo } from "./assets";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 24 * 60 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});

function App() {
  const notistackRef = React.createRef();
  const { consultantInfo } = useContentSetting();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  console.log = () => {};

  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("wheel", handleWheel, { passive: true });
    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  useEffect(() => {
    const handleInput = (e) => {
      if (e.target.type === "number") {
        const value = parseFloat(e.target.value);
        if (value < 0) {
          e.target.value = 0;
        }
      }
    };

    const handleKeyDown = (e) => {
      if (e.target.type === "number") {
        if (e.key === "-" || e.key === "e" || e.key === "E") {
          e.preventDefault();
        }
      }
    };

    document.addEventListener("input", handleInput);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("input", handleInput);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ContextPGIMode>
        <ThemeConfig>
          <GlobalStyles />
          <SnackbarProvider
            ref={notistackRef}
            action={(key) => (
              <Button
                className="snackbar-cross-icon"
                onClick={onClickDismiss(key)}
              >
                <CloseIcon />
              </Button>
            )}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            TransitionComponent={Slide}
            maxSnack={3}
            style={{ zIndex: 9999999999 }}
          >
            <Helmet>
              <title>{consultantInfo?.meta_title}</title>
              <meta
                name="description"
                content={consultantInfo?.meta_description}
              />
              <link rel="icon" type="image/x-icon" href={loginLogo} />
            </Helmet>
            <ChatContext>
              <Routers />
            </ChatContext>
          </SnackbarProvider>
        </ThemeConfig>
      </ContextPGIMode>
    </QueryClientProvider>
  );
}

export default App;
